import { useQuery, useSubscription } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { OC_ASSETS_SUBSCRIPTION } from "oc/graphql";
import getCorrectBase64Image from "oc/utils/get-correct-base64-image";

export const OC_GET_AVATAR = gql`
  query readFileAsset($employeeCode: String!, $type: String!) {
    readFileAsset(employeeCode: $employeeCode, type: $type) {
      _id
      filename
      createdAt
    }
  }
`;

export const useOcAvatar = ({ employee }: { employee: string }) => {
  const { data, loading, error, refetch } = useQuery(OC_GET_AVATAR, {
    fetchPolicy: "cache-and-network",
    skip: !employee,
    variables: {
      employeeCode: employee,
      type: "avatar",
    },
  });

  useSubscription(OC_ASSETS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    skip: !employee,
    onData: () => {
      refetch();
    },
  });

  let src = data?.readFileAsset?.filename
    ? getCorrectBase64Image(data?.readFileAsset?.filename)
    : "/img/defaultAvatar.png";

  return {
    data: src,
    loading,
    error,
    refetch,
  };
};

export default useOcAvatar;
